import { useEffect } from "react";
import { useLocation } from "react-router";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    const error = new Error(`404 Error: User attempted to access non-existent route: ${location.pathname}`);
    console.error(error);

    toast.error("Page Not Found", {
      description: "The page you're looking for doesn't exist.",
    });
  }, [location.pathname, toast]);

  return (
    <div className="container mx-auto py-16 px-4">
      <Alert variant="destructive" className="max-w-md mx-auto">
        <AlertTitle>404 - Page Not Found</AlertTitle>
        <AlertDescription>
          The page you're looking for doesn't exist. Please check the URL or go back to the homepage.
        </AlertDescription>
      </Alert>
      <div className="mt-4 text-center">
        <Button asChild className="mt-4">
          <a href="/">Return Home</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
